<div class="container">
  <div class="row justify-content-center py-5 align-items-center">
    <div class="col-lg-5 align-items-center py-5">
      <div class="row justify-content-center">
        <div class="col-10 py-4">
          <img src="/img/logo.svg" class="pb-3 img-fluid">
          <div class="border w-50 mx-auto mt-4 mb-5 login-hr"></div>
          <div class="form-group row">
            <div class="col-12" [formGroup]="loginForm">
              <label for="inputId" class="sr-only">Identifiant Pickup (composé de 7 caractères)</label>
              <input type="text" class="form-control mb-3" id="inputId" formControlName="pickupId">
            </div>
          </div>
          <div class="row">
            <div class="col-12 form-group">
              <button class="btn btn-lg btn-primary btn-block w-100"
                      (click)="onLogin()"
                      [disabled]="!loginForm.valid"
              >
                Connexion
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
